import { render, staticRenderFns } from "./warning.vue?vue&type=template&id=6300fcc8&"
import script from "./warning.vue?vue&type=script&lang=js&"
export * from "./warning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6300fcc8')) {
      api.createRecord('6300fcc8', component.options)
    } else {
      api.reload('6300fcc8', component.options)
    }
    module.hot.accept("./warning.vue?vue&type=template&id=6300fcc8&", function () {
      api.rerender('6300fcc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/warning.vue"
export default component.exports